export function accessLevelFromToken(token) {
  if (!token) return null;
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = JSON.parse(atob(payload));
    return json.accessLevel || null;
  } catch {
    return null;
  }
}

export function currentAccessLevel() {
  const token = localStorage.getItem('token');
  return accessLevelFromToken(token) || localStorage.getItem('userType') || 'user';
}

export function homeForAccess(userType) {
  if (userType === 'black') return '/black';
  if (userType === 'admin') return '/admin-dashboard';
  return '/';
}
